import type { CustomTitleDirective, CustomTitleDirectiveBinding } from "./types";

export const customTitle: CustomTitleDirective = {
  /**
   * mounted 钩子：当指令绑定到元素且元素已插入到 DOM 时调用。
   */
  //@ts-ignore
  mounted(el: HTMLElement, binding: CustomTitleDirectiveBinding) {
    // 获取指令值
    const value = binding.value;
    const content = typeof value === "string" ? value : value.content;
    if (!content) return;
    el.title = content;
  }

  /**
   * updated 钩子：当包含指令的组件 VNode 更新后调用。
   */
};

// 扩展 HTMLElement 接口以存储我们的处理函数引用
//@ts-ignore
declare module "@vue/runtime-core" {
  interface HTMLElement {
    __customTitle_mouseenter_handler__?: (event: MouseEvent) => void;
    __customTitle_mouseleave_handler__?: () => void;
  }
}
